export const homeSliders_TNTT = [
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088062/480860921_637471268932194_9068669105249330496_n_uirzje.jpg',
        title: 'ICPC 2024',
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747086788/481261998_122212798934179744_4690783054352845121_n_a3c6ye.jpg',
        title: 'SV5T',
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
]

export const TNTT_2020_2021 = [
    {
        imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088215/480515163_632055932807061_1436810788247120444_n_qxmbkv.jpgg',
        title: 'CÔNG NHẬN DANH HIỆU THANH NIÊN TIÊN TIẾN LÀM THEO LỜI BÁC NĂM HỌC 2023 - 2024',
        content:
            '🎉Mỗi lĩnh vực đều có những cá nhân tiêu biểu với những thành tích vượt bậc là niềm tự hào và tấm gương cho các bạn sinh viên nôi theo. Hy vọng các bạn sẽ phấn đấu hơn nữa không những duy trì mà ngày càng phát triển đạt nhiều thành tích ở nhiều lĩnh vực khác nhau....',
    }
]

export const awards_TNTT_2020_2021 = [
    [
        {
            imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088217/480525545_632054679473853_1592113623565833133_n_k2gopo.jpg',
            title: 'Trần Công Toản',
            sid: 'CNTT'
        },
        {
            imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088228/480520753_632054812807173_1400222627195964998_n_s8im46.jpg',
            title: 'Văn Thị Mười Ngọc',
            sid: 'CNTT'
        },
        {
            imgUrl: 'https://res.cloudinary.com/dp5xqgbsj/image/upload/v1747088254/480252904_632054666140521_3180643101715248110_n_kuw2kj.jpg',
            title: 'Đỗ Thị Bích Ngọc',
            sid: 'CNTT'
        },
    ],
]